import React from 'react';
import { connect } from 'react-redux';
import { firebaseConnect } from 'react-redux-firebase';
import { compose } from 'redux';
import { translate } from 'react-i18next';
import { Row, Col, Tabs } from 'antd';
import { Link } from 'react-router-dom';
import { changeClass, changeClassFilter, yearChange } from '../../actions';
const TabPane = Tabs.TabPane;

class Classes extends React.Component {
  state = {
    classes: null
  };

  componentDidMount() {
    this.props.changeClass('All');
  }

  selectClass = (id, subject, name, grade, subjectId, students) => {
    this.props.changeClassFilter('reset');
    this.props.changeClass(id, subject, name, grade, subjectId, students);
    this.props.history.push(`${this.props.match.path}/generalinfo`);
  };

  selectGrade = grade => {
    if (grade !== 'None') {
      this.props.changeClassFilter('grade', grade);
      if (this.props.match.path == '/myclasses' && this.props.auth) {
        let teacher = {
          id: this.props.auth.uid,
          name: this.props.profile.name + ' ' + this.props.profile.last_name
        };
        this.props.changeClassFilter('teacher', teacher);
      }
      this.props.history.push('/school/generalinfo');
    }
  };

  translateGrade = grade => {
    const { t } = this.props;
    if (grade) {
      grade = grade.split(' ');
      grade[0] = t(grade[0]);
      if (grade[0] === 'Niveau scolaire') {
        grade[0] = 'Niv. S.';
      }
      return grade.join(' ');
    } else {
      return '';
    }
  };

  componentDidUpdate(prevProps) {
    if (prevProps !== this.props) {
      let classes = {};

      if (this.props.classes && this.props.subjects) {
        this.props.classes.map(element => {
          // let subject = Object.entries(this.props.subjects);
          // subject = subject.filter(subject => subject[0] == element[1].subject);
          // subject = subject[0][1].name;

          if (classes[element[1].subject_category]) {
            if (classes[element[1].subject_category][element[1].grade]) {
              classes[element[1].subject_category][element[1].grade].push({
                className: element[1].name,
                subject:
                  this.props.subjects &&
                  this.props.subjects[element[1].subject] &&
                  this.props.subjects[element[1].subject].name,
                id: element[0],
                subjectId: element[1].subject,
                students:
                  element[1].students && Object.keys(element[1].students)
              });
            } else {
              classes[element[1].subject_category][element[1].grade] = [];
              classes[element[1].subject_category][element[1].grade].push({
                className: element[1].name,
                subject:
                  this.props.subjects &&
                  this.props.subjects[element[1].subject] &&
                  this.props.subjects[element[1].subject].name,
                id: element[0],
                subjectId: element[1].subject,
                students:
                  element[1].students && Object.keys(element[1].students)
              });
            }
          } else {
            classes[element[1].subject_category] = {};
            classes[element[1].subject_category][element[1].grade] = [];
            classes[element[1].subject_category][element[1].grade].push({
              className: element[1].name,
              subject:
                this.props.subjects &&
                this.props.subjects[element[1].subject] &&
                this.props.subjects[element[1].subject].name,
              id: element[0],
              subjectId: element[1].subject,
              students: element[1].students && Object.keys(element[1].students)
            });
          }
        });
      }
      let classArray = Object.entries(classes);
      this.setState({ classes: classArray });
    }
  }

  sortGrades = (a, b) => {
    a = a[0];
    b = b[0];
    function chunkify(t) {
      var tz = [],
        x = 0,
        y = -1,
        n = 0,
        i,
        j;

      while ((i = (j = t.charAt(x++)).charCodeAt(0))) {
        var m = i == 46 || (i >= 48 && i <= 57);
        if (m !== n) {
          tz[++y] = '';
          n = m;
        }
        tz[y] += j;
      }
      return tz;
    }

    var aa = chunkify(a);
    var bb = chunkify(b);

    for (let x = 0; aa[x] && bb[x]; x++) {
      if (aa[x] !== bb[x]) {
        var c = Number(aa[x]),
          d = Number(bb[x]);
        if (c == aa[x] && d == bb[x]) {
          return c - d;
        } else return aa[x] > bb[x] ? 1 : -1;
      }
    }
    return aa.length - bb.length;
  };

  render() {
    let { classes } = this.state;

    if (classes && classes[1]) {
    }
    const { t, allYears, currentYear } = this.props;

    return (
      <div style={{ margin: '0px 20px' }}>
        <Tabs
          type="card"
          activeKey={currentYear.year && currentYear.year.text}
          onTabClick={year =>
            this.props.changeYear(
              allYears.filter(item => item.text === year)[0]
            )
          }>
          {allYears &&
            allYears.map(year => (
              <TabPane
                style={{
                  backgroundColor: 'white',
                  minWidth: 400
                }}
                tab={year.text}
                key={year.text}>
                <div
                  style={{
                    padding: '0px 40px 40px 40px',
                    backgroundColor: 'white',
                    margin: '0px 20px 20px 20px'
                  }}>
                  {classes &&
                    classes.map(element => (
                      <div style={{ overflow: 'auto' }}>
                        <h1
                          style={{
                            fontWeight: 'bold',
                            paddingTop: 40,
                            marginBottom: 10,
                            marginTop: 0,
                            clear: 'both'
                          }}>
                          {t(element[0])}
                        </h1>
                        <div>
                          {Object.entries(element[1])
                            .sort(this.sortGrades)
                            .map((grade, index) => (
                              <Row
                                style={{
                                  height: 110,
                                  marginBottom: '20px',
                                  clear: 'both'
                                }}>
                                <Col span={1} style={{ height: 110 }}>
                                  <div
                                    className="gradename"
                                    onClick={() => this.selectGrade(grade[0])}
                                    style={{
                                      backgroundColor: colors[index],
                                      fontSize: '20px'
                                    }}>
                                    {grade[0] == 'None'
                                      ? ''
                                      : this.translateGrade(grade[0])}
                                  </div>
                                </Col>
                                {grade[1].map((clss, i) => (
                                  <Col
                                    span={7}
                                    offset={[3, 6, 9, 12, 15].includes(i) && 1}
                                    style={{ padding: '0px 10px' }}>
                                    <div
                                      className="classBlock"
                                      style={{ backgroundColor: colors[index] }}
                                      onClick={() =>
                                        this.selectClass(
                                          clss.id,
                                          clss.subject,
                                          clss.className,
                                          grade[0],
                                          clss.subjectId,
                                          clss.students
                                        )
                                      }>
                                      <h3
                                        style={{
                                          color: 'white',
                                          marginBottom: 0,
                                          fontSize: '20px'
                                        }}>
                                        {t(clss.subject)}
                                      </h3>
                                      <h3
                                        style={{
                                          color: 'white',
                                          fontSize: '20px'
                                        }}>
                                        ({t(clss.className)})
                                      </h3>
                                    </div>
                                  </Col>
                                ))}
                              </Row>
                            ))}
                        </div>
                      </div>
                    ))}
                </div>
              </TabPane>
            ))}
        </Tabs>
      </div>
    );
  }
}

function mapDispatchToProps(dispatch) {
  return {
    changeClass: (id, subject, name, grade, subjectId, students) => {
      dispatch(changeClass(id, subject, name, grade, subjectId, students));
    },
    changeClassFilter: (type, value) => {
      dispatch(changeClassFilter(type, value));
    },
    changeYear: year => {
      dispatch(yearChange(year));
    }
  };
}

const enhancer = compose(
  translate('lang'),
  firebaseConnect(props => {
    return ['/subjects'];
  }),
  connect(state => {
    return {
      classes: state.classes.classes,
      subjects: state.firebase.data.subjects,
      auth: state.firebase && state.firebase.auth,
      profile: state.firebase && state.firebase.profile.profile,
      currentYear: state.currentYear,
      allYears: state.allYears && state.allYears.years
    };
  }, mapDispatchToProps)
);
export default enhancer(Classes);

const colors = [
  '#557282',
  '#78A8C1',
  '#8EC6E5',
  '#557282',
  '#78A8C1',
  '#8EC6E5',
  '#557282',
  '#78A8C1',
  '#8EC6E5',
  '#557282',
  '#78A8C1',
  '#8EC6E5'
];



// WEBPACK FOOTER //
// ./src/containers/Classes/index.js